import { Table, Button, Popconfirm, Tooltip, notification, Spin, Input, Tag, Avatar, Modal } from "antd";
import { CustomModal } from "../common/CustomModal";
import * as React from "react";
import { getDepartments, getDepartmentDetails, revokeDepartmentCourse, revokeDepartmentUser } from "../../Graphs/Department/GetDepartment";
import { deleteDepartment } from "../../Graphs/Department/DeleteDepartment";
import { createDepartment } from "../../Graphs/Department/AddDepartment";
import { updateDepartment } from "../../Graphs/Department/UpdateDepartment";
import { EditOutlined, DeleteOutlined, EyeOutlined, BookOutlined, UserOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { Formik } from "formik";

class DepartmentRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      pagination: {
        pageSize: 10,
        current: 1,
      },
      visible: false,
      isEditMode: false,
      selectedDepartmentId: null,
      selectedDepartment: "",
      detailsModalVisible: false,
      loadingDetails: false,
      departmentDetails: null,
      activeTabKey: "courses",
      primaryColor: "#5C6AC4",
    };
    this.handleTableChange = this.handleTableChange.bind(this);
  }

  async componentDidMount() {
    // Store a reference to this component instance in window
    window.departmentTableRef = this;
    
    const primaryColor = (await localStorage.getItem("primary_color")) || "#5C6AC4";
    this.setState({ primaryColor });

    this.fetchDepartments();
  }

  componentWillUnmount() {
    // Clean up the reference when component unmounts
    if (window.departmentTableRef === this) {
      window.departmentTableRef = null;
    }
  }

  async fetchDepartments() {
    try {
      this.setState({ isLoading: true });
      const { authToken } = this.props;
      const response = await getDepartments(authToken, 0, 10);
      if (response.status === 200) {
        this.setState({
          data: response.data,
        });
      }
    } catch (error) {
      console.error("Failed to fetch departments:", error);
    } finally {
      this.setState({ isLoading: false });
    }
  }
  
  async deleteDepartment(id) {
    try {
      const { authToken } = this.props;
      console.log("Auth token: ", authToken)
      const response = await deleteDepartment(id, authToken);
      console.log(id)
      if (response.status === 200) {
        notification.success({
          message: "Delete Department",
          description: "Successfully deleted the department.",
        });
        this.fetchDepartments(); // Refresh data after deletion
      }
    } catch (error) {
      notification.error({
        message: "Delete Department",
        description: "Failed to delete the department.",
      });
    }
  }

  // ✅ Handle Revoke Course Access from Department
  handleRevokeCourse = async (courseId) => {
    const { departmentDetails } = this.state;
    const deptInfo = departmentDetails?.department;
    if (!deptInfo || !deptInfo._id) return;

    try {
      const { authToken } = this.props;
      const payload = {
        department_id: deptInfo._id,
        course_id: courseId,
      };

      const response = await revokeDepartmentCourse(authToken, payload);
      if (response && (response.status === 200 || response.status === 201)) {
        notification.success({
          message: "Course Access Revoked",
          description: "Course access revoked from department successfully.",
        });
        // Re-fetch department details to instantly update table and counters
        const detailsRes = await getDepartmentDetails(authToken, deptInfo._id);
        if (detailsRes && detailsRes.status === 200) {
          this.setState({
            departmentDetails: detailsRes.data,
          });
        }
        this.fetchDepartments();
      } else {
        notification.error({
          message: "Revocation Failed",
          description: response?.message || "Failed to revoke course access.",
        });
      }
    } catch (error) {
      console.error("Error revoking course access:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while revoking course access.",
      });
    }
  };

  // ✅ Handle Revoke User from Department
  handleRevokeUser = async (userId) => {
    const { departmentDetails } = this.state;
    const deptInfo = departmentDetails?.department;
    if (!deptInfo || !deptInfo._id) return;

    try {
      const { authToken } = this.props;
      const payload = {
        department_id: deptInfo._id,
        user_id: userId,
      };

      const response = await revokeDepartmentUser(authToken, payload);
      if (response && (response.status === 200 || response.status === 201)) {
        notification.success({
          message: "User Revoked",
          description: "User removed from department successfully.",
        });
        // Re-fetch department details to instantly update table and counters
        const detailsRes = await getDepartmentDetails(authToken, deptInfo._id);
        if (detailsRes && detailsRes.status === 200) {
          this.setState({
            departmentDetails: detailsRes.data,
          });
        }
        this.fetchDepartments();
      } else {
        notification.error({
          message: "Revocation Failed",
          description: response?.message || "Failed to remove user from department.",
        });
      }
    } catch (error) {
      console.error("Error revoking user from department:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while removing user from department.",
      });
    }
  };

  // ✅ Handle View Details Modal
  handleViewDetails = async (record) => {
    this.setState({
      detailsModalVisible: true,
      loadingDetails: true,
      departmentDetails: null,
      activeTabKey: "courses",
    });

    try {
      const { authToken } = this.props;
      const response = await getDepartmentDetails(authToken, record._id);
      if (response && response.status === 200) {
        this.setState({
          departmentDetails: response.data,
        });
      } else {
        notification.error({
          message: "Fetch Details Failed",
          description: response?.message || "Failed to fetch department details.",
        });
      }
    } catch (error) {
      console.error("Error fetching department details:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while fetching department details.",
      });
    } finally {
      this.setState({ loadingDetails: false });
    }
  };

  closeDetailsModal = () => {
    this.setState({
      detailsModalVisible: false,
      departmentDetails: null,
      activeTabKey: "courses",
    });
  };

  // ✅ Handle Modal Open for Add/Edit Mode
  openModal = (record = null) => {
    this.setState({
      visible: true,
      isEditMode: record ? true : false,
      selectedDepartmentId: record ? record._id : null,
      selectedDepartment: record ? record.name : "",
    });
  };

  closeModal = () => {
    this.setState({
      visible: false,
      selectedDepartmentId: null,
      selectedDepartment: "",
      isEditMode: false,
    });
  };

  // ✅ Handle Form Submission
  handleSubmit = async (values) => {
    const { authToken } = this.props;
    const { isEditMode, selectedDepartmentId } = this.state;

    try {
      let response;
      if (isEditMode) {
        // UPDATE Department
        response = await updateDepartment(authToken, {
          id: selectedDepartmentId,
          name: values.department,
        });
      } else {
        // CREATE Department
        response = await createDepartment(authToken, {
          name: values.department,
        });
      }

      if (response.status === 200 || response.status === 201) {
        notification.success({
          message: isEditMode ? "Edit Department" : "Create Department",
          description: `Department ${
            isEditMode ? "updated" : "created"
          } successfully.`,
        });
        this.fetchDepartments();
        this.closeModal();
      }
    } catch (error) {
      console.error("Error:", error);
      notification.error({
        message: isEditMode ? "Edit Department" : "Create Department",
        description: `Failed to ${
          isEditMode ? "update" : "create"
        } department.`,
      });
    }
  };

  handleTableChange(pagination) {
    this.setState({ pagination }, () => this.fetchDepartments());
  }

  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 70,
      render: (text, item, index) => {
        const { current, pageSize } = this.state.pagination;
        const serialNumber = (current - 1) * pageSize + index + 1;
        return (
          <div>
            <span>{serialNumber}</span>
          </div>
        );
      },
    },
    {
      title: "Department Name",
      key: "name",
      render: (text, record) => (
        <strong>
          <Tooltip title="Department Name">{record.name || "-"}</Tooltip>
        </strong>
      ),
    },
    {
      title: "Actions",
      key: "action",
      width: 180,
      render: (text, record) => {
        const { primaryColor } = this.state;
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <Tooltip title="View Details">
              <Button
                shape="circle"
                icon={<EyeOutlined style={{ color: primaryColor }} />}
                onClick={() => this.handleViewDetails(record)}
              />
            </Tooltip>
            <Tooltip title="Edit">
              <Button
                shape="circle"
                icon={<EditOutlined />}
                onClick={() => this.openModal(record)}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure to delete this department?"
              onConfirm={() => this.deleteDepartment(record._id)}
              okText="Yes"
              cancelText="No"
              placement="topRight"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <Tooltip title="Delete">
                <Button
                  shape="circle"
                  icon={<DeleteOutlined style={{ color: "#ff4d4f" }} />}
                />
              </Tooltip>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  getCourseColumns = () => {
    const { primaryColor } = this.state;
    return [
      {
        title: "Sr. No.",
        key: "sn",
        width: 70,
        render: (text, record, index) => index + 1,
      },
      {
        title: "Course Name",
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <span style={{ fontWeight: 600 }}>
            <BookOutlined style={{ marginRight: 8, color: primaryColor }} />
            {text || record.course_id?.name || "N/A"}
          </span>
        ),
      },
      {
        title: "Max Users",
        dataIndex: "max_user_count",
        key: "max_user_count",
        render: (count) => (
          <Tag style={{ backgroundColor: `${primaryColor}15`, color: primaryColor, border: `1px solid ${primaryColor}30`, borderRadius: "12px" }}>
            {count !== undefined && count !== null ? count : "Unlimited"}
          </Tag>
        ),
      },
      {
        title: "Assign Count",
        dataIndex: "assign_count",
        key: "assign_count",
        render: (count) => <span style={{ fontWeight: 500 }}>{count || 0}</span>,
      },
      {
        title: "Action",
        key: "action",
        width: 140,
        render: (text, record) => {
          const targetCourseId = record._id || record.course_id?._id || record.course_id;
          return (
            <Popconfirm
              title="Are you sure to revoke access to this course for this department?"
              onConfirm={() => this.handleRevokeCourse(targetCourseId)}
              okText="Yes"
              cancelText="No"
              placement="topRight"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <Button type="link" danger size="small" icon={<DeleteOutlined />}>
                Revoke Access
              </Button>
            </Popconfirm>
          );
        },
      },
    ];
  };

  getUserColumns = () => {
    return [
      {
        title: "Sr. No.",
        key: "sn",
        width: 70,
        render: (text, record, index) => index + 1,
      },
      {
        title: "User Name",
        key: "user_name",
        render: (text, record) => {
          const fullName = `${record.first_name || ""} ${record.last_name || ""}`.trim() || record.username || "N/A";
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Avatar icon={<UserOutlined />} src={record.profile_image_url} />
              <span style={{ fontWeight: 500 }}>{fullName}</span>
            </div>
          );
        },
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        render: (email) => email || "-",
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
        render: (phone) => phone || "-",
      },
      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        render: (isActive) => (
          <Tag color={isActive ? "green" : "red"}>
            {isActive ? "Active" : "Inactive"}
          </Tag>
        ),
      },
      {
        title: "Action",
        key: "action",
        width: 140,
        render: (text, record) => (
          <Popconfirm
            title="Are you sure to remove this user from this department?"
            onConfirm={() => this.handleRevokeUser(record._id)}
            okText="Yes"
            cancelText="No"
            placement="topRight"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          >
            <Button type="link" danger size="small" icon={<DeleteOutlined />}>
              Remove User
            </Button>
          </Popconfirm>
        ),
      },
    ];
  };

  render() {
    const {
      isLoading,
      data,
      pagination,
      visible,
      selectedDepartment,
      detailsModalVisible,
      loadingDetails,
      departmentDetails,
      activeTabKey,
      primaryColor,
    } = this.state;

    const deptInfo = departmentDetails?.department;
    const assignedCourses = departmentDetails?.assigned_courses || [];
    const deptUsers = departmentDetails?.users || [];
    const createdDateRaw = deptInfo?.insertedAt || deptInfo?.createdAt;

    return (
      <>
        {/* ✅ Table */}
        {isLoading ? (
          <Spin size="large" style={{ marginLeft: "50%", marginTop: "100px" }} />
        ) : (
          <Table
            rowKey={(record) => record._id}
            columns={this.columns}
            dataSource={data}
            pagination={pagination}
            onChange={this.handleTableChange}
          />
        )}

        {/* ✅ Add/Edit Modal */}
        <CustomModal
          destroyOnClose={true}
          title={this.state.isEditMode ? "Edit Department" : "Add Department"}
          visible={visible}
          onCancel={this.closeModal}
          footer={null}
          maskClosable={false}
        >
          <Formik
            initialValues={{
              department: selectedDepartment || "",
            }}
            onSubmit={this.handleSubmit}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              resetForm, 
            }) => (
              <div>
                <div className="formik-field_wrap">
                  <div className="formik-field-left">
                    Department
                    <Input
                      id="department"
                      placeholder="Enter Department Name"
                      value={values.department}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <Button
                  type="primary"
                  style={{
                    marginTop: "19px",
                    background: primaryColor,
                    borderColor: primaryColor,
                    color: "#fff",
                  }}
                  onClick={handleSubmit}
                  loading={isSubmitting}
                >
                  {this.state.isEditMode ? "Update" : "Add"}
                </Button>
              </div>
            )}
          </Formik>
        </CustomModal>

        {/* ✅ View Department Details Modal */}
        <CustomModal
          destroyOnClose={true}
          title={`Department Details - ${deptInfo?.name || ""}`}
          visible={detailsModalVisible}
          onCancel={this.closeDetailsModal}
          footer={null}
          width="850px"
          maskClosable={true}
        >
          {loadingDetails ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Spin size="large" />
            </div>
          ) : (
            <div>
              {/* Header Stats */}
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  marginBottom: "20px",
                  background: "#f7f8fa",
                  padding: "16px",
                  borderRadius: "8px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h4 style={{ margin: 0, color: "#1f2937", fontWeight: 700 }}>
                    {deptInfo?.name || "Department"}
                  </h4>
                  <span style={{ color: "#6b7280", fontSize: "12px" }}>
                    Created on: {createdDateRaw ? new Date(createdDateRaw).toLocaleDateString() : "N/A"}
                  </span>
                </div>
                <div style={{ display: "flex", gap: "12px" }}>
                  <Tag
                    style={{
                      fontSize: "13px",
                      padding: "4px 12px",
                      borderRadius: "12px",
                      backgroundColor: `${primaryColor}15`,
                      color: primaryColor,
                      border: `1px solid ${primaryColor}30`,
                      fontWeight: 500,
                    }}
                  >
                    <BookOutlined style={{ marginRight: 6 }} />
                    Assigned Courses: {assignedCourses.length}
                  </Tag>
                  <Tag
                    style={{
                      fontSize: "13px",
                      padding: "4px 12px",
                      borderRadius: "12px",
                      backgroundColor: `${primaryColor}15`,
                      color: primaryColor,
                      border: `1px solid ${primaryColor}30`,
                      fontWeight: 500,
                    }}
                  >
                    <UserOutlined style={{ marginRight: 6 }} />
                    Total Users: {deptUsers.length}
                  </Tag>
                </div>
              </div>

              {/* Navigation Tabs */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginBottom: "16px",
                  borderBottom: "1px solid #e5e7eb",
                  paddingBottom: "12px",
                }}
              >
                <Button
                  type={activeTabKey === "courses" ? "primary" : "default"}
                  style={{
                    borderRadius: "6px",
                    background: activeTabKey === "courses" ? primaryColor : "#fff",
                    borderColor: activeTabKey === "courses" ? primaryColor : "#d9d9d9",
                    color: activeTabKey === "courses" ? "#fff" : "#595959",
                  }}
                  icon={<BookOutlined />}
                  onClick={() => this.setState({ activeTabKey: "courses" })}
                >
                  Assigned Courses ({assignedCourses.length})
                </Button>
                <Button
                  type={activeTabKey === "users" ? "primary" : "default"}
                  style={{
                    borderRadius: "6px",
                    background: activeTabKey === "users" ? primaryColor : "#fff",
                    borderColor: activeTabKey === "users" ? primaryColor : "#d9d9d9",
                    color: activeTabKey === "users" ? "#fff" : "#595959",
                  }}
                  icon={<UserOutlined />}
                  onClick={() => this.setState({ activeTabKey: "users" })}
                >
                  Department Users ({deptUsers.length})
                </Button>
              </div>

              {/* Tab Content */}
              {activeTabKey === "courses" && (
                <Table
                  rowKey={(record, index) => record._id || index}
                  columns={this.getCourseColumns()}
                  dataSource={assignedCourses}
                  pagination={{ pageSize: 5 }}
                  size="small"
                />
              )}

              {activeTabKey === "users" && (
                <Table
                  rowKey={(record) => record._id}
                  columns={this.getUserColumns()}
                  dataSource={deptUsers}
                  pagination={{ pageSize: 5 }}
                  size="small"
                />
              )}
            </div>
          )}
        </CustomModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(DepartmentRecordsTable);